import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from './theme';

const useStyles = createMemoStyles(({ palette }: HeaderTheme) => ({
  navSection: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
